import React from 'react';
import { Button } from '@material-ui/core';
import { getState } from '../../../../../../redux/store';
import { ReducerKeys } from '../../../../../../redux/reducers';
import { FixedEstablishmentInput } from '../../model';
import { useDispatch } from 'react-redux';
import RegistrationDetailActions from '../../../../../../redux/reducers/registration_detail_reducer/actions';

interface IActionsProps {
  rowIndex: number;
  mode: 'VIEW' | 'EDIT';
}

export default function ActionBlock(props: IActionsProps) {
  const dispatch = useDispatch();

  const deleteRow = (index: number) => {
    let newData: Array<FixedEstablishmentInput> = new Array<FixedEstablishmentInput>();
    let reduxData = getState(ReducerKeys.REGISTRATION_DETAIL_REDUCER)
      .fixedEstablishments;
    for (let i in reduxData) {
      if (Number.parseInt(i) !== index) newData.push(reduxData[i]);
    }
    dispatch(RegistrationDetailActions.setFixedEstablishment(newData));
  };

  return (
    <Button
      disabled={props.mode === 'VIEW'}
      onClick={() => deleteRow(props.rowIndex)}
    >
      Delete
    </Button>
  );
}
